module.exports = __webpack_public_path__ + "img/silver4.2cd950b1.png";